const separateThousand = (value: string | number = '') =>
  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

export default separateThousand
